/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GoogleCallback$Params {
  state: string;
  code?: (string | null);
  error?: (string | null);
}

export function googleCallback(http: HttpClient, rootUrl: string, params: GoogleCallback$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, googleCallback.PATH, 'get');
  if (params) {
    rb.query('state', params.state, {});
    rb.query('code', params.code, {});
    rb.query('error', params.error, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

googleCallback.PATH = '/integrations/google/callback';
